import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  appPath,
  getInterfacePreference,
  loginDestination,
} from "@/lib/app-version";
import { isAuthenticated } from "../utils/token";

export function AuthGuard() {
  const location = useLocation();
  if (!isAuthenticated()) {
    return (
      <Navigate
        to={appPath("/login", location.pathname)}
        state={{ from: location }}
        replace
      />
    );
  }
  return <Outlet />;
}

export function GuestGuard() {
  const location = useLocation();
  if (isAuthenticated()) {
    const destination = loginDestination(
      location.pathname,
      location.state?.from,
      getInterfacePreference(),
    );
    return <Navigate to={destination} replace />;
  }
  return <Outlet />;
}
